import { Box } from '@mui/material';

import { LiveEvent } from '@/types';
import { LiveEventCardMarketSection } from './LiveEventCardMarketSection';
import { LiveEventCardMobileMoneyline } from './LiveEventCardMobileMoneyline';
import { LiveEventCardTeamRow } from './LiveEventCardTeamRow';

import { MONEYLINE_TEAM1_COLOR, MONEYLINE_TEAM2_COLOR } from '@/constants';

interface LiveEventCardNormalLayoutProps {
  event: LiveEvent;
  onTeamClick: (event: LiveEvent, index: 1 | 2) => void;
  showSpreads: boolean;
  isDarkMode: boolean;
}

export function LiveEventCardNormalLayout({
  event,
  onTeamClick,
  showSpreads,
  isDarkMode,
}: LiveEventCardNormalLayoutProps) {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: 1.5,
      }}
    >
      <LiveEventCardTeamRow
        event={event}
        teamIndex={1}
        onTeamClick={onTeamClick}
        moneylineColor={MONEYLINE_TEAM1_COLOR}
        hideButton={true}
      />
      <LiveEventCardTeamRow
        event={event}
        teamIndex={2}
        onTeamClick={onTeamClick}
        moneylineColor={MONEYLINE_TEAM2_COLOR}
        hideButton={true}
      />

      {/* Mobile Only Betting Buttons */}
      <Box sx={{ display: { xs: 'flex', md: 'none' }, flexDirection: 'column', gap: 1.5 }}>
        <LiveEventCardMobileMoneyline event={event} onTeamClick={onTeamClick} />

        {showSpreads && (event.spread1 || event.totalOver) && (
          <Box
            sx={{
              mt: 0.5,
              pt: 1.5,
              borderTop: '1px solid',
              borderColor: 'divider',
            }}
          >
            <LiveEventCardMarketSection
              title="SPREAD"
              option1={event.spread2}
              option2={event.spread1}
            />
            <LiveEventCardMarketSection
              title="TOTAL"
              option1={event.totalOver}
              option2={event.totalUnder}
            />
          </Box>
        )}
      </Box>
    </Box>
  );
}
